module.exports = __webpack_public_path__ + "static/schmink1-e49ccff674303eeff34549338f72830b.jpg";